import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { formatCurrencyValue } from '../../../lib/currencyFormatters';
import { store } from '../../../store';

const Subtotal = styled.p`
  margin: 0;
  font-weight: bold;
`;

const ItemPriceDisplay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  line-height: 1.1;

  @media only screen and (max-width: 767px) {
    position: initial;
    margin: 12px 0;
  }
`;

export const ItemSubtotal = ({ itemSubtotal }) => {
  const {
    language: lang,
    page: { locale },
    orderInfo: { orderCurrencyCode } = {},
  } = store.getState();
  const displayPrice =
    (itemSubtotal &&
      formatCurrencyValue({
        value: itemSubtotal,
        locale,
        currencyCode: orderCurrencyCode,
      })) ||
    itemSubtotal ||
    lang['returns.general.display_price'];

  return (
    <ItemPriceDisplay className="item-price-display returnItem-module_item_subtotal_container_">
      <Subtotal className="returnItem-module_item_subtotal_">{displayPrice}</Subtotal>
    </ItemPriceDisplay>
  );
};

ItemSubtotal.defaultProps = {
  itemSubtotal: null,
};

ItemSubtotal.propTypes = {
  itemSubtotal: PropTypes.string,
};
